import { MarketMoverType } from "../reducers/marketMovers"
import { ApiError, AppThunk } from "../misc"
import { ClusterContentApi } from "@cluster/web-components"

export enum MARKET_MOVERS_ACTIONS {
  FETCH_MARKET_MOVERS_START = "FETCH_MARKET_MOVERS_START",
  FETCH_MARKET_MOVERS_SUCCESS = "FETCH_MARKET_MOVERS_SUCCESS",
  FETCH_MARKET_MOVERS_ERROR = "FETCH_MARKET_MOVERS_ERROR",
}

export type MARKET_MOVERS_ACTION_TYPES = FetchMarketMoversAction

export type FetchMarketMoversAction = {
  type: MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_START | MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_SUCCESS | MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_ERROR,
  payload: {
    items: MarketMoverType[],
    latest_day: Date | null,
  },
  error?: ApiError
}

export const doGetMarketMovers = (): AppThunk => async (dispatch, getState, api) => {
  dispatch({type: MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_START});
  try {
    let data = await api.fetchMarketMovers();

    let marketMovers: MarketMoverType[] = data.market_movers?.map((item: ClusterContentApi.MarketMoverRaw) => {
      return {
        id: item.id,
        title: item.title,
        direction: item["field-direction"],
        topic: item["field-topic"]?.name,
        topic_img_src: (item["field-topic"]) ? item["field-topic"]["field-icon"] ? item["field-topic"]["field-icon"].uri.url : undefined : undefined,
        cellId: item["field-api-cell-id"],
        date: item["field-date"],
        author: item.uid.name
      }
    });

    return dispatch({
      type: MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_SUCCESS,
      payload: {
        items: marketMovers,
        latest_day: data.day,
      }
    } as FetchMarketMoversAction);

  } catch (error) {
    let message = "An unknown error has occured"

    dispatch({
      type: MARKET_MOVERS_ACTIONS.FETCH_MARKET_MOVERS_ERROR,
      error: {
        userMessage: message
      }
    });
  }
}